import axios from 'axios';
import { useState, useEffect } from 'react';
import * as settings from '../config/settings';

const API_URL = `${settings.APIBASEURL}`;
const DEVICE_TOKEN_KEY = 'deviceToken';

export default function useDeviceToken() {
    const [deviceToken, setDeviceToken] = useState(() => {
        return localStorage.getItem(DEVICE_TOKEN_KEY) || '';
    });

    useEffect(() => {
        if (deviceToken) return;

        (async () => {
            // Try to get existing token from server cookie
            try {
                const res = await axios.get(`${API_URL}/get-cookie`, {
                    withCredentials: true
                });

                if (res && res.data && res.data !== '') {
                    localStorage.setItem(DEVICE_TOKEN_KEY, res.data);
                    setDeviceToken(res.data);
                    return;
                }
            } catch (error) {
                console.error('Error fetching device token:', error);
            }

            // Fallback: request server to generate a new token
            try {
                const res = await axios.get(`${API_URL}/set-cookie`, {
                    withCredentials: true
                });

                if (res && res.data && res.data !== '') {
                    localStorage.setItem(DEVICE_TOKEN_KEY, res.data);
                    setDeviceToken(res.data);
                    return;
                }
            } catch (error) {
                console.error('Error setting device token:', error);
            }

            // Last resort: generate client-side token
            const fallbackToken = crypto.randomUUID();
            localStorage.setItem(DEVICE_TOKEN_KEY, fallbackToken);
            setDeviceToken(fallbackToken);
        })();
    }, [deviceToken]);

    return deviceToken;
}
